module.exports = __webpack_public_path__ + "static/img/icon_94_jinghua.7f7fdac3.png";